import React, {useEffect, useState} from 'react'
import { useD3 } from '../../hooks/useD3';
import * as d3 from 'd3'
import './timeline.css'

function Timeline({ data, xAxisProp, yAxisProp, seriesProp }) {
    const laneIndex = []
    const laneIndexRev = []
    let i = 0
    data.forEach((d) => {
        laneIndex[d[yAxisProp]] = i
        laneIndexRev[i] = d[yAxisProp]
        i = i + 1
    })

    const ref = useD3(
    (svg) => {
      const height = 1200;
      const width = 1500;
      const margin = { top: 20, right: 30, bottom: 30, left: 120 };
      const onMarkerClick = (e, d) => {
          alert(d[yAxisProp] + "\n" + d[xAxisProp] + "\n" + d.action)
      }
      const accent = d3.scaleOrdinal(d3.schemeTableau10);
      const color = (d) => {

        if(!d) return "#eeeeee"
        if(d["action"].endsWith("success")) return "#00ff0077"
        if(d["action"].endsWith("failure")) return "#ff000077"
        if(d["action"].endsWith("received")) return "#0088dd77"
        return "#aaaabb88"
      }
      const barWidth = (d) => {
        if(!d) return 1
        if(d["action"].endsWith("success")) return 5
        if(d["action"].endsWith("failure")) return 2
        if(d["action"].endsWith("received")) return 2
        return 2
      }
      const laneId = (d) => {
          return laneIndex[d[yAxisProp]]
      }
      const x = d3
          .scaleTime()
          .domain(d3.extent(data, d => d[xAxisProp]))
          .range([margin.left, width-margin.right])


      const yDomain = data.map(d => laneId(d))
      const y = d3
        .scaleBand()
        .domain(yDomain)
        .rangeRound([height - margin.bottom, margin.top])

      const xAxis = (g) =>
        g.attr("transform", `translate(0, ${height - margin.bottom})`).call(
          d3
            .axisBottom(x)
            .ticks(10)
        );

      const y1Axis = (g) =>
        g
          .attr("transform", `translate(${margin.left},0)`)
          .style("color", "#00000022")
          .call(d3.axisLeft(y).ticks(null, "s").tickFormat((t) => laneIndexRev[t]).tickSize(-width + margin.left + margin.right))
          .call((g) => g.select(".domain").remove())
          .call((g) =>
            g
              .append("text")
              .attr("x", -margin.left)
              .attr("y", 10)
              .attr("fill", "#666666")
              .attr("text-anchor", "start")
              .text(yAxisProp)
          );

      svg.select(".x-axis").call(xAxis);
      svg.select(".y-axis").call(y1Axis);

      svg
        .select(".plot-area")
        .selectAll(".bar")
        .data(data)
        .join("rect")
        .attr("class", "bar")
        .attr("fill", (d) => color(d)) // accent(d.action)
        .attr("x", (d) => x(d[xAxisProp]))
        .attr("width", (d) => barWidth(d))
        .attr("y", (d) => y(laneId(d))-2)
        .attr("height", 5)
        .on('click', onMarkerClick)
    },
    [data.length]
  );

  return (
    <svg
      ref={ref}
      style={{
        height: 1200,
        width: 1500,
        marginRight: "0px",
        marginLeft: "0px",
      }}
    >
      <g className="plot-area" />
      <g className="x-axis" />
      <g className="y-axis" />
    </svg>
  );
}

export default Timeline